export enum FlagCategory {
  Customer = 'Customer',
  Ground = 'Ground',
  Air = 'Air',
  SRInfo = 'SR Info',
  Documentation = 'Documentation',
  Catering = 'Catering',
}

export enum FlagCategoryColor {
  Customer = '#F91C96',
  Ground = '#F9B31C',
  Air = '#1CD8F9',
  SRInfo = '#5E1CF9',
  Documentation = '#04A329',
  Catering = '#A900F2',
}
